import ExprInput from '../../../builtin/designerComponents/ExprInput';
import { propPanelMixin } from '../../../helpers';
const __script_base__ = {
  name: 'RenderCondition',
  mixins: [propPanelMixin],
  components: {
    ExprInput
  },
  computed: {
    displayCondition: {
      get() {
        return this.comp.displayCondition;
      },
      set(val) {
        this.modifyComp(layout => {
          if (val) this.$set(layout, 'displayCondition', val);else if ('displayCondition' in layout) this.$delete(layout, 'displayCondition');
        });
      }
    },
    renderCondition: {
      get() {
        return this.comp.renderCondition;
      },
      set(val) {
        this.modifyComp(layout => {
          if (val) this.$set(layout, 'renderCondition', val);else if ('renderCondition' in layout) this.$delete(layout, 'renderCondition');
        });
      }
    },
    keepAlive: {
      get() {
        return this.comp.keepAlive;
      }
    }
  },
  methods: {
    onKeepAliveChange(e) {
      const val = e.target.checked;
      this.modifyComp(layout => {
        if (val) this.$set(layout, 'keepAlive', true);else if ('keepAlive' in layout) this.$delete(layout, 'keepAlive');
      });
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [!_vm.isLogicComponent ? _c("p", [_c("label", [_c("input", {
    staticClass: "uc-checkbox",
    attrs: {
      type: "checkbox"
    },
    domProps: {
      checked: !!_vm.displayCondition
    },
    on: {
      change: function ($event) {
        $event.preventDefault();
        return function () {
          _vm.displayCondition = _vm.displayCondition ? "" : "1 == 1";
        }.apply(null, arguments);
      }
    }
  }), _vm._v("\n      按条件决定是否可见\n      "), _c("a-tooltip", {
    attrs: {
      title: "可编写一段 JavaScript 表达式，表达式为真时，才显示元素"
    }
  }, [_c("a-icon", {
    attrs: {
      type: "question-circle"
    }
  })], 1)], 1), _vm._v(" "), !!_vm.displayCondition ? _c("expr-input", {
    attrs: {
      lazy: "",
      "notify-void-return": true
    },
    model: {
      value: _vm.displayCondition,
      callback: function ($$v) {
        _vm.displayCondition = $$v;
      },
      expression: "displayCondition"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c("p", [_c("label", [_c("input", {
    staticClass: "uc-checkbox",
    attrs: {
      type: "checkbox"
    },
    domProps: {
      checked: !!_vm.renderCondition
    },
    on: {
      change: function ($event) {
        $event.preventDefault();
        return function () {
          _vm.renderCondition = _vm.renderCondition ? "" : "1 == 1";
        }.apply(null, arguments);
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.isLogicComponent ? "按条件启用触发器" : "按条件实例化组件") + "\n\n      "), !_vm.isLogicComponent ? _c("a-tooltip", {
    attrs: {
      title: "上面那个只是在样式上隐藏，但是仍然会实例化组件。如果你的组件有特殊逻辑，需要 v-if，请用这个"
    }
  }, [_c("a-icon", {
    attrs: {
      type: "question-circle"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), !!_vm.renderCondition ? _c("expr-input", {
    attrs: {
      lazy: "",
      "notify-void-return": true
    },
    model: {
      value: _vm.renderCondition,
      callback: function ($$v) {
        _vm.renderCondition = $$v;
      },
      expression: "renderCondition"
    }
  }) : _vm._e()], 1), _vm._v(" "), !_vm.isLogicComponent && _vm.renderCondition ? _c("p", [_c("label", [_c("input", {
    staticClass: "uc-checkbox",
    attrs: {
      type: "checkbox"
    },
    domProps: {
      checked: _vm.keepAlive
    },
    on: {
      change: function ($event) {
        $event.preventDefault();
        return _vm.onKeepAliveChange.apply(null, arguments);
      }
    }
  }), _vm._v("\n      组件保活\n      "), _c("a-tooltip", {
    attrs: {
      title: "保活的组件只会实例化一次，之后会缓存起来避免重复实例化，提高性能"
    }
  }, [_c("a-icon", {
    attrs: {
      type: "question-circle"
    }
  })], 1)], 1)]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/components/RenderCondition.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);